import { Shield } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Data Protection | Promptliteracy.ai</title>
        <meta name="description" content="Learn about Promptliteracy.ai's privacy policy, data collection practices, and how we protect your personal information while providing AI literacy education." />
        
        {/* Open Graph */}
        <meta property="og:title" content="Privacy Policy - Data Protection | Promptliteracy.ai" />
        <meta property="og:description" content="Learn about Promptliteracy.ai's privacy policy, data collection practices, and data protection measures for AI literacy education." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://promptliteracy.ai/privacy" />
        <meta property="og:site_name" content="Promptliteracy.ai" />
        
        {/* Additional SEO */}
        <meta name="keywords" content="privacy policy, data protection, GDPR compliance, AI education privacy, newsletter privacy, analytics privacy" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://promptliteracy.ai/privacy" />
      </Helmet>

      {/* Header Section */}
      <section className="relative py-20 bg-primary text-white overflow-hidden">
        {/* Background decorations */}
        <div className="container relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Shield className="h-8 w-8" />
              <h1 className="text-4xl md:text-5xl font-bold">Privacy Policy</h1>
            </div>
            <p className="text-xl opacity-90 leading-relaxed">
              How we protect and handle your data
            </p>
          </div>
        </div>
      </section>
      
      <section className="py-12 bg-primary/3 relative overflow-hidden">
        <div className="absolute inset-0 circuit-pattern opacity-10" />
        <div className="container relative z-10">
        <div className="max-w-4xl mx-auto">
          <Card className="card-slate">
            <CardHeader>
              <CardTitle className="text-2xl text-primary">Data Collection & Usage</CardTitle>
            </CardHeader>
            <CardContent className="prose max-w-none">
              <p className="text-muted-foreground mb-4">
                This privacy policy will be fully implemented in Phase 3 of development. 
                Currently, we collect minimal data to provide our educational services.
              </p>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold mb-2">Newsletter Subscriptions</h3>
                  <p className="text-muted-foreground">
                    Email addresses collected through our newsletter signup are processed through Formspree 
                    and used solely for delivering educational content updates.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold mb-2">Analytics</h3>
                  <p className="text-muted-foreground">
                    We use Google Analytics to understand how our site is used, helping us improve 
                    the educational experience for all users.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold mb-2">Contact</h3>
                  <p className="text-muted-foreground">
                    For privacy-related questions, please contact us at hello@promptliteracy.ai
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        </div>
      </section>
    </>
  );
}